'use client';

import cx from 'classnames';

import { useCopy } from '@flipster/features/src/shared/webview/clipboard';
import ShareIcon from '@flipster/ui/assets/svgs/share.svg';

import { FlipsterUrl } from '@web/constants/metadata';

import { GlossaryPageGlossaryTermFragment } from '../query.generated';
import styles from './index.module.scss';

const ShareTermButton = ({
  className,
  glossaryTerm,
}: {
  className?: string;
  glossaryTerm: GlossaryPageGlossaryTermFragment;
}) => {
  const copy = useCopy('Glossary link copied');
  const url = `${FlipsterUrl}/glossary/${glossaryTerm.slug}`;

  const onClickShareTermButton = () => {
    if (navigator.share) {
      navigator.share({ title: document.title, url });
    } else {
      copy(url);
    }
  };

  return (
    <button
      className={cx(styles.button, className)}
      type='button'
      onClick={onClickShareTermButton}
      aria-label='Copy the term link to the clipboard'
    >
      <ShareIcon className={styles.share} />
    </button>
  );
};

export default ShareTermButton;
